import { computed as i, onBeforeMount as a, watchEffect as m } from "vue";
import { useSsrAdapter as p } from "./ghl-ui.es648.js";
import { cssrAnchorMetaName as d } from "./ghl-ui.es1270.js";
import { exists as l } from "./ghl-ui.es1163.js";
function v(r, o, c) {
  if (!o)
    return;
  const n = p(), s = i(() => {
    const { value: t } = o;
    if (!t)
      return;
    const e = t[r];
    if (e)
      return e;
  }), u = () => {
    m(() => {
      const { value: t } = c, e = `${t}${r}Rtl`;
      if (l(e, n))
        return;
      const { value: f } = s;
      f && f.style.mount({
        id: e,
        head: !0,
        anchorMetaName: d,
        props: {
          bPrefix: t ? `.${t}-` : void 0
        },
        ssr: n
      });
    });
  };
  return n ? u() : a(u), s;
}
export {
  v as useRtl
};
